module.exports = __webpack_public_path__ + "images/icon/copy_button-6af74b49.svg";